import axios from "axios";

/**
 * Dedicated client for masterconfig microservice.
 * Base URL from VITE_MASTERCONFIG_BASE_URL, else VITE_SUPERADMIN_BASE_URL.
 */
const masterconfigBaseURL = (
  import.meta.env.VITE_MASTERCONFIG_BASE_URL ||
  import.meta.env.VITE_SUPERADMIN_BASE_URL ||
  ""
).replace(/\/$/, "");

const masterconfigAxios = axios.create({
  baseURL: masterconfigBaseURL,
});

masterconfigAxios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");
    if (!config.headers.Authorization && token) {
      config.headers.Authorization = `Bearer ${token.replace(/"/g, "")}`;
    }

    // FormData must get multipart boundary from the browser — never force JSON/multipart.
    if (typeof FormData !== "undefined" && config.data instanceof FormData) {
      if (typeof config.headers.set === "function") {
        config.headers.set("Content-Type", undefined as any);
      } else {
        delete (config.headers as any)["Content-Type"];
        delete (config.headers as any)["content-type"];
      }
    } else if (!config.headers["Content-Type"] && !config.headers["content-type"]) {
      config.headers["Content-Type"] = "application/json";
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export { masterconfigBaseURL };
export default masterconfigAxios;
